module.exports = __webpack_public_path__ + "img/conference-2010.68468a93.jpg";